import { IToastConfig } from 'src/common/primitives/Toast';

export function generateMemberDeleteSuccessToast(
  firstName: string
): IToastConfig {
  return {
    type: 'success',
    title: `${firstName} has been deleted.`,
    description: 'You can restore their membership at any time.',
  };
}
